var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-player-timer caption font-weight-bold grey--text",class:{
    'text--lighten-1': _vm.type === 'total',
    'text--darken-1': _vm.type === 'current',
  },domProps:{"textContent":_vm._s(_vm.value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }